var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.337 5.711c.193.112.38.24.546.406.451.452.695 1.025.757 1.614.025.24.024.484-.016.723-.08.473-.282.929-.616 1.313l-.125.135-2.647 2.647a2.668 2.668 0 01-1.893.784A2.676 2.676 0 013.35 8.871l.101-.106L4.914 7.3a3.16 3.16 0 00-.08.69l.008.089c.005.16.021.318.049.473l.031.154-.764.765a1.679 1.679 0 000 2.37c.316.317.738.491 1.185.491.403 0 .784-.14 1.087-.4l.098-.09 2.656-2.658.031-.038c.61-.656.6-1.684-.04-2.322a1.658 1.658 0 00-.45-.32l-.127-.055.739-.739zm1.32-3.044a2.676 2.676 0 011.994 4.462l-.101.106L11.086 8.7c.05-.224.081-.454.081-.69l-.009-.09a3.168 3.168 0 00-.049-.472l-.031-.154.764-.764A1.677 1.677 0 009.57 4.067l-.098.09L8.27 5.36h.003L6.829 6.806l-.013.01a1.679 1.679 0 00.008 2.36c.136.136.29.243.458.323l.127.055-.74.739a2.53 2.53 0 01-.551-.41A2.65 2.65 0 015.36 8.27a2.677 2.677 0 01.016-.722c.08-.474.283-.93.616-1.313l.126-.136L8.765 3.45a2.666 2.666 0 011.892-.784z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconLink.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };